import React from "react"
import Lottie from "lottie-react-web"
import { Pressable, View, Text } from "react-native"
import { View as AnimatableView, } from "react-native-animatable"

import { onPressA2HS } from "../../services/A2HSUtils";
import { getChemistAppLogo } from "../../services/chemist/ChemistStoreUtils"

import { IconView } from "../CommonWidget/Icons"

import AppTheme from "../../../AppTheme"
import TextStyle from "../../../TextStyle"
import AppStyles from "../../../AppStyles"
import Colors from "../../constants/AppColors"

import a2hsLottie from '../../../assets/animation/a2hs.json';

const A2HSDashboardView = () => {
    return <AnimatableView key={'A2HS Dashboard View'}
        animation="slideInDown" duration={AppTheme.transitionDuration} >
        <Pressable style={[AppStyles.flexRowSpaceBetween, {
            backgroundColor: Colors.primary, paddingVertical: 14,
            paddingLeft: 16, paddingRight: 24
        }]} onPress={() => onPressA2HS()}>
            <IconView size={36} icon={'aayu_logo.svg'}
                iconPath={getChemistAppLogo()} />
            <View style={{ paddingHorizontal: 12, width: AppTheme.appWidth - 30 - 32 - 40 }}>
                <Text style={[TextStyle.text14b, { color: Colors.white }]}>
                    Install the App</Text>
                <Text style={[TextStyle.text14, { color: Colors.white, marginTop: 2 }]}>
                    For fast and smooth experience. Tap here.</Text>
            </View>
            <View style={[AppStyles.p8, AppStyles.border12, { backgroundColor: Colors.violet.bg, }]}>
                <Lottie width={14} height={20}
                    options={{ animationData: a2hsLottie }} />
            </View>
        </Pressable>
    </AnimatableView>
}

export default A2HSDashboardView